module.exports = __webpack_public_path__ + "static/img/28-北京市海淀北部新区实验学校(初中部)1.7f23020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/28-北京市海淀北部新区实验学校(初中部)1.png
// module id = R0bA
// module chunks = 0